/**
 * @generated SignedSource<<a4f494493ae454bccadb28d55b61b271>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteAttributeDefinitionInput = {
  id: string;
};
export type DeleteAttributeDefinitionDialogMutation$variables = {
  input: DeleteAttributeDefinitionInput;
};
export type DeleteAttributeDefinitionDialogMutation$data = {
  readonly deleteAttributeDefinition: {
    readonly deletedAttributeDefinitionId: string;
  };
};
export type DeleteAttributeDefinitionDialogMutation = {
  response: DeleteAttributeDefinitionDialogMutation$data;
  variables: DeleteAttributeDefinitionDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAttributeDefinitionId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteAttributeDefinitionDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteAttributeDefinitionPayload",
        "kind": "LinkedField",
        "name": "deleteAttributeDefinition",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteAttributeDefinitionDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteAttributeDefinitionPayload",
        "kind": "LinkedField",
        "name": "deleteAttributeDefinition",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d2aa76435080a4f766a0e798435d8dba",
    "id": null,
    "metadata": {},
    "name": "DeleteAttributeDefinitionDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteAttributeDefinitionDialogMutation(\n  $input: DeleteAttributeDefinitionInput!\n) {\n  deleteAttributeDefinition(input: $input) {\n    deletedAttributeDefinitionId\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8cc08090246b1322c61a725ccb2faff8";

export default node;
